import { render, staticRenderFns } from "./DashboardAxerta.vue?vue&type=template&id=dc163f26&scoped=true&"
import script from "./DashboardAxerta.vue?vue&type=script&lang=js&"
export * from "./DashboardAxerta.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAxerta.vue?vue&type=style&index=0&id=dc163f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc163f26",
  null
  
)

export default component.exports